import { useContent } from "../contexts/ContentContext";
import { Sparkles } from "lucide-react";

const FALLBACK = {
  enabled: true,
  background_color: "#047857",
  text_color: "#ffffff",
  speed_seconds: 38,
  items: [
    "Admissions Open for 2026 Batches",
    "GPAT Crash Course Starts Soon \u2014 Limited Seats",
    "Scholarships up to 25% for Merit Students",
    "Doubt-Solving Support Mon to Sat",
    "Talk to a Counsellor Today",
  ],
};

export default function Ticker() {
  const { content } = useContent();
  const t = content?.ticker || FALLBACK;
  if (t.enabled === false) return null;

  const items = (t.items || []).filter(Boolean);
  if (items.length === 0) return null;

  const speed = Math.max(8, Number(t.speed_seconds) || 38);
  const sequence = [...items, ...items]; // duplicate for seamless loop

  return (
    <div
      data-testid="hero-ticker"
      className="relative overflow-hidden border-y border-black/10"
      style={{ backgroundColor: t.background_color || "#047857", color: t.text_color || "#ffffff" }}
    >
      <div
        className="flex whitespace-nowrap py-3 lg:py-3.5"
        style={{ animation: `sb-marquee ${speed}s linear infinite`, willChange: "transform" }}
      >
        {sequence.map((text, i) => (
          <span
            key={i}
            data-testid={i < items.length ? `ticker-item-${i}` : undefined}
            className="flex items-center gap-3 px-8 text-sm lg:text-base font-medium tracking-tight"
          >
            <Sparkles className="h-4 w-4 opacity-80 shrink-0" />
            <span>{text}</span>
            <span className="opacity-50 ml-3" aria-hidden="true">•</span>
          </span>
        ))}
      </div>

      <style>{`
        @keyframes sb-marquee {
          from { transform: translateX(0); }
          to   { transform: translateX(-50%); }
        }
        @media (prefers-reduced-motion: reduce) {
          [data-testid="hero-ticker"] > div { animation: none !important; }
        }
        [data-testid="hero-ticker"]:hover > div { animation-play-state: paused; }
      `}</style>
    </div>
  );
}
